module.exports = __webpack_public_path__ + "img/cover.4eeb36df.jpg";